import { FunctionComponent, useCallback } from "react";

import { useIsMobile } from "@src/common/styles/media";
import {
  CloseIcon,
  ModalHeaderWrapper,
  Text,
} from "@src/modules/shared/components/Modal/ModalHeader/ModalHeader.components";
import useModal from "@src/modules/shared/components/Modal/useModal";

interface Props {
  showCloseIcon?: boolean;
}

const ModalHeader: FunctionComponent<Props> = ({ showCloseIcon, children }) => {
  const { closeModal } = useModal();
  const isMobile = useIsMobile();

  const handleClick = useCallback(() => closeModal(), [closeModal]);

  return (
    <ModalHeaderWrapper>
      <Text>{children}</Text>
      {(showCloseIcon || isMobile) && <CloseIcon onClick={handleClick} />}
    </ModalHeaderWrapper>
  );
};

export default ModalHeader;
